"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
exports.view = view;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ReactRedux = __importStar(require("react-redux"));
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Loaders = __importStar(require("@genesys/client-core/lib/loaders"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const product_property_search_state_1 = require("./product-property-search-state");
const Root = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
const SettingsContainer = styled_components_1.default.div `
  flex: 0 0 auto;
  padding: 20px;
  h3 {
    padding: 5px 0;
  }
  ul {
    li {
      padding: 5px;
    }
  }

  button {
    margin: 20px 0;
  }
`;
const ResultContainer = styled_components_1.default.div `
  flex: 1 0 auto;
  textarea {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #ebebeb;
    box-sizing: border-box;
    resize: none;
  }
`;
const queryProduct = (0, graphql_tag_1.default) `
  query ProductPropertySearchProduct {
    product {
      activeSystemTypes {
        id
        allProducts {
          id
          properties {
            id
            name
          }
        }
      }
    }
  }
`;
const productPropertySearchQuery = (0, graphql_tag_1.default) `
  query ProductPropertySearch($input: ProductPropertySearchInputType!) {
    product {
      productPropertySearch(input: $input)
    }
  }
`;
function view({ state, dispatch }) {
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, productData => (React.createElement(Loaders.PleaseWaitOverlayLoaderIndicator, { active: state.loading },
        React.createElement(Root, null,
            React.createElement(SettingsContainer, null,
                React.createElement(React.Fragment, null,
                    React.createElement("h3", null, "With this tool you can do a full search after usages of a given property name within a product id. Of course, there is probably holes in this search, but it contains the most of the places properties are used. Note!! Will not search property filters that are NOT valid, so do a product validation and correct those errors first."),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement(Elements.SelectBox, { value: state.settings.systemTypeId || "please-select", onChange: e => {
                                    dispatch(product_property_search_state_1.Action.ProductPropertySearchSetSettings(Object.assign(Object.assign({}, state.settings), { systemTypeId: e.target.value, productId: undefined, propertyName: undefined })));
                                } },
                                React.createElement("option", { value: "please-select" }, "Please select"),
                                productData.product.activeSystemTypes
                                    .concat()
                                    .sort((a, b) => a.id.localeCompare(b.id))
                                    .map(p => (React.createElement("option", { key: p.id, value: p.id }, p.id)))),
                            state.settings.systemTypeId && (React.createElement(Elements.SelectBox, { value: state.settings.productId || "please-select", onChange: e => {
                                    dispatch(product_property_search_state_1.Action.ProductPropertySearchSetSettings(Object.assign(Object.assign({}, state.settings), { productId: e.target.value, propertyName: undefined })));
                                } },
                                React.createElement("option", { value: "please-select" }, "Please select"),
                                productData.product.activeSystemTypes
                                    .flatMap(x => x.allProducts)
                                    .sort((a, b) => a.id.localeCompare(b.id))
                                    .filter(p => p.id.startsWith(state.settings.systemTypeId))
                                    .map(p => (React.createElement("option", { key: p.id, value: p.id }, p.id))))),
                            state.settings.productId && (React.createElement(Elements.SelectBox, { value: state.settings.propertyName || "please-select", onChange: e => {
                                    dispatch(product_property_search_state_1.Action.ProductPropertySearchSetSettings(Object.assign(Object.assign({}, state.settings), { propertyName: e.target.value })));
                                } },
                                React.createElement("option", { value: "please-select" }, "Please select"),
                                productData.product.activeSystemTypes
                                    .flatMap(x => x.allProducts)
                                    .find(x => x.id === state.settings.productId)
                                    .properties.concat()
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map(p => (React.createElement("option", { key: p.name, value: p.name }, p.name))))))),
                    React.createElement(Elements.StandardButton, { disabled: state.settings.propertyName === undefined, onClick: () => {
                            dispatch(product_property_search_state_1.Action.ProductPropertySearchToggleLoader());
                            GraphQLRequest.request(productPropertySearchQuery, {
                                input: {
                                    productId: state.settings.productId,
                                    propertyName: state.settings.propertyName
                                }
                            }, true, config.graphqlEndpoint, config.authorization).then(result => {
                                dispatch(product_property_search_state_1.Action.ProductPropertySearchSetResult(result.product.productPropertySearch));
                            });
                        } }, "Search"))),
            React.createElement(ResultContainer, null,
                React.createElement("textarea", { readOnly: true, value: state.messages.join("\n") })))))))));
}
exports.View = ReactRedux.connect((state) => ({ state: state.ui.productPropertySearch }))(view);
//# sourceMappingURL=product-property-search-view.js.map